import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map, startWith } from 'rxjs';
import { APP_ROUTES } from '../../core/constants/app-navigation.constants';

const NO_PADDING_ROUTES: readonly string[] = [`/${APP_ROUTES.HOME}`, `/${APP_ROUTES.ERROR}`, '/'];

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './landing.html',
  styleUrl: './landing.scss',
})
export class Landing {
  private readonly router = inject(Router);

  private readonly isNoPaddingUrl = (url: string) => NO_PADDING_ROUTES.includes(url.split('?')[0]);

  protected readonly isNoPaddingRoute = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => this.isNoPaddingUrl(event.urlAfterRedirects)),
      startWith(this.isNoPaddingUrl(this.router.url)),
    ),
    { initialValue: this.isNoPaddingUrl(this.router.url) },
  );
}
